import React from "react";
import { View, StyleSheet, Image,Text } from "react-native";

export default function Logo_Cabecera() {
  return (
    <View style={Styles.LogoLogin}>
      <Image
        style={Styles.imagen}
        source={require("../../assets/Logo.png")}
      />
      <Text  style={{fontSize:18, fontFamily:"FontBold", marginTop:20}}>INICIO DE SESIÓN</Text>
    </View>
  );
}
const Styles = StyleSheet.create({
  LogoLogin: {
    //alignItems: "center",
    backgroundColor: "#fff", //Imagen Superior
    //textAlign: "center",
    padding: 0,
    margin: 0,
    alignItems: "center",
  },
  imagen: {
    width: "80%",
    resizeMode: "contain",
    overflow: "hidden",
    marginTop: 20,
    // maxWidth: 350,
    height: 150,
  },
});
